// extracted by mini-css-extract-plugin
export var displayNone = "_mj-6";
export var imgContainer = "_mj-2";
export var overflowHidden = "_mj-3";
export var productInfoCardButtonContainer = "_mj-5";
export var productTitleText = "_mj-4";
export var rightArrow = "_mj-1";
export var rightArrowContainer = "_mj-0";